export default __webpack_public_path__ + "static/media/icon-sap.3723ee07.png";